import React from 'react';
import Pricing from '../../components/AdminNext/Pricing';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Pricing — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <Pricing />
      </HeadLessLayout>
    )
  };
}

export default action;
